import React from "react";
import { IEmployer } from "../../types";
import { DetailsItem } from "./detail-item";

interface EmployerDetailsProps {
  employer: IEmployer;
}

const EmployerDetails = ({ employer }: EmployerDetailsProps) => {
  return (
    <div className="border shadow-sm p-4 rounded-lg">
      <p className="text-xl mb-2">Employer Details</p>
      <div className="flex flex-col space-y-2">
        <DetailsItem
          label="Company Name"
          value={employer.companyName}
          disabled
        />
        <DetailsItem
          label="Notification Email"
          value={employer.notificationEmail}
          disabled
        />
        <DetailsItem
          label="Registration No"
          value={employer.registrationNo}
          disabled
        />
        {/* <DetailsItem label="Website" value={employer.website} disabled /> */}
        <DetailsItem
          label="Area of Specialization"
          value={employer.areaOfSpecialization}
          disabled
        />
        <DetailsItem
          label="Office Address"
          value={employer.officeAddress}
          disabled
        />
      </div>
    </div>
  );
};

export default EmployerDetails;
